import React from 'react';
import { Link } from 'react-router-dom';
import { Scale, FileText, Shield, Cookie, FileCheck, ArrowRight } from 'lucide-react';
import { Badge } from '../components/Badge';
export function Legal() {
  const docs = [{
    icon: Shield,
    title: 'Privacy Policy',
    desc: 'How we collect, use, and protect your personal data.',
    to: '/privacy'
  }, {
    icon: FileText,
    title: 'Terms of Service',
    desc: 'The rules and guidelines for using Akios BOS.',
    to: '/terms'
  }, {
    icon: Cookie,
    title: 'Cookie Policy',
    desc: 'How we use cookies and similar technologies on our site.',
    to: '/privacy'
  }, {
    icon: FileCheck,
    title: 'Data Processing Agreement',
    desc: 'Our commitments under applicable data protection laws.',
    to: '/contact'
  }];
  return <div className="w-full" data-id="element-522">
      <section className="pt-20 pb-16 bg-gradient-to-b from-white via-slate-50 to-indigo-50/40" data-id="element-523">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-524">
          <Badge icon={<Scale className="w-3.5 h-3.5" data-id="element-526" />} text="LEGAL" data-id="element-525" />
          <h1 className="text-5xl md:text-6xl font-black leading-[1.05] tracking-tight mb-6 text-[#0B1020]" data-id="element-527">
            Legal & <span className="text-brand-blue" data-id="element-528">Compliance</span>
          </h1>
          <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-529">
            Transparency matters. Find all our legal documents, policies, and
            compliance information here.
          </p>
        </div>
      </section>

      <section className="py-16 bg-white" data-id="element-530">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-531">
          <div className="grid sm:grid-cols-2 gap-5" data-id="element-532">
            {docs.map(doc => <Link key={doc.title} to={doc.to} className="group p-6 rounded-2xl border border-slate-200 hover:shadow-lg hover:-translate-y-1 transition-all bg-white block" data-id="element-533">
                <div className="w-12 h-12 rounded-xl bg-blue-50 text-brand-blue flex items-center justify-center mb-4" data-id="element-534">
                  <doc.icon className="w-6 h-6" data-id="element-535" />
                </div>
                <h3 className="text-lg font-bold mb-2 flex items-center gap-2" data-id="element-536">
                  {doc.title}
                  <ArrowRight className="w-4 h-4 text-slate-400 group-hover:text-brand-blue group-hover:translate-x-1 transition-all" data-id="element-537" />
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-538">
                  {doc.desc}
                </p>
              </Link>)}
          </div>
        </div>
      </section>
    </div>;
}